import {createSelector} from '@ngrx/store';

import {IAppState} from '@app/core/store/state/app.state';
import {INotificationsState} from '@app/core/store/state/notifications.state';

const _selectNotifications = (state: IAppState) => state.notifications;

export const selectIsNotificationsLoading = createSelector(
	_selectNotifications,
	(state: INotificationsState) => state.isLoading,
);

export const selectNotifications = createSelector(
	_selectNotifications,
	(state: INotificationsState) => state.notifications,
);

export const selectNotificationsCount = createSelector(
	_selectNotifications,
	(state: INotificationsState) => state.notificationNumbers.total_amount_of_notifications,
);

export const selectNotificationNumbers = createSelector(
	_selectNotifications,
	(state: INotificationsState) => state.notificationNumbers,
);
export const selectShowNotifications = createSelector(
	_selectNotifications,
	(state: INotificationsState) => state.showNotifications,
);
